var _path, _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEggSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 77,
    viewBox: "0 0 52 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_193_5378",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 52,
    height: 77
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52 49.4448C52 64.6631 40.3594 77 26 77C11.6406 77 0 64.6631 0 49.4448C0 29.0714 16.2985 0 26 0C35.7015 0 52 29.0714 52 49.4448Z",
    fill: "url(#paint0_linear_193_5378)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_193_5378)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52 49.4448C52 64.6631 40.3594 77 26 77C11.6406 77 0 64.6631 0 49.4448C0 29.0714 16.2985 0 26 0C35.7015 0 52 29.0714 52 49.4448Z",
    fill: "url(#paint1_linear_193_5378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 49.4448C52 64.6631 40.3594 77 26 77C11.6406 77 0 64.6631 0 49.4448C0 29.0714 16.2985 0 26 0C35.7015 0 52 29.0714 52 49.4448Z",
    fill: "url(#paint2_linear_193_5378)",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.775391 39.2857C0.873231 39.622 1.02791 40.16 1.239 40.801C2.939 45.4316 5.78976 44.7158 7.9765 44C13.5774 40.4643 19.9783 42.4286 21.9787 44.3928C25.5115 47.5357 31.1852 48.5833 33.5804 48.7143H39.555C39.5617 48.7038 39.5704 48.7035 39.5814 48.7143H39.555C39.4214 48.9222 40.1001 53.1521 40.3021 53.8271C40.3205 53.8252 40.339 53.8233 40.3575 53.8214C40.3575 53.9541 40.3368 53.9431 40.3021 53.8271C32.7301 54.5919 27.3399 51.4557 20.9545 47.9286C14.5535 44.3928 12.1731 44 7.3724 46.75C4.23626 48.5465 2.17872 43.6543 1.239 40.801C1.07292 40.3486 0.917815 39.8451 0.775391 39.2857Z",
    fill: "url(#paint3_linear_193_5378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.775391 39.2857C0.916437 39.7705 1.17562 40.6197 1.5516 41.566C3.27314 45.3471 5.91881 44.6735 7.9765 44C13.5774 40.4643 19.9783 42.4286 21.9787 44.3928C25.5115 47.5357 31.1852 48.5833 33.5804 48.7143H39.555C39.5617 48.7039 39.5704 48.7035 39.5814 48.7143H39.555C39.4218 48.9217 40.0963 53.1287 40.3004 53.8214C40.3194 53.8214 40.3384 53.8214 40.3575 53.8214C40.3575 53.9562 40.3362 53.9427 40.3004 53.8214C32.9553 53.8092 27.339 51.4552 20.9545 47.9286C14.5535 44.3928 12.1731 43.2143 7.3724 45.9643C4.54735 47.5825 2.59753 44.1985 1.5516 41.566C1.26491 40.9363 1.00384 40.1831 0.775391 39.2857Z",
    fill: "url(#paint4_linear_193_5378)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.53226,
    cy: 19.2877,
    rx: 7.53226,
    ry: 19.2877,
    transform: "matrix(0.93892 -0.344134 0.336738 0.941598 36.1523 10.6841)",
    fill: "#00FF9A"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.80428,
    cy: 11.6257,
    rx: 4.80428,
    ry: 11.6257,
    transform: "matrix(0.973221 -0.229871 0.224576 0.974457 25.9912 17.9361)",
    fill: "url(#paint5_linear_193_5378)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 5.46591,
    cy: 19.756,
    rx: 5.46591,
    ry: 19.756,
    transform: "matrix(-0.972499 -0.232908 0.22755 -0.973766 8.80469 45.7358)",
    fill: "url(#paint6_linear_193_5378)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5223 16.1806C16.2984 13.3571 19.4029 7.85713 24.4477 6.28571C28.7666 10.6456 36.7241 22.5223 43.3987 68.8958C44.0269 72.0666 47.325 70.217 48.8955 68.8958C48.6679 69.8914 47.9125 71.3044 46.3999 71.9457C47.1839 75.644 45.5705 82.0552 33.7033 84.4392C17.4209 87.7102 6.56589 70.9462 5.01518 63.1776C3.77461 56.9626 6.04899 55.6815 7.34125 55.8177C7.72893 55.8177 9.2021 55.6542 11.9934 55C16.2578 59.4976 24.3991 63.5864 28.2758 64.8131C33.7697 66.0329 38.7918 64.9782 41.0173 64.1671C40.5095 60.0329 39.7497 54.6006 38.6799 48.7143H33.5814C31.1862 48.5833 25.5125 47.5357 21.9796 44.3928C19.9793 42.4286 13.5783 40.4643 7.97747 44C5.57711 44.7857 2.37661 45.5714 0.776367 39.2857C1.30978 41.119 3.33676 44.2357 7.17735 42.0357C11.9781 39.2857 15.5786 38.8928 21.9796 42.4286C28.1359 45.8291 31.3318 47.4127 38.3295 46.8298C37.2699 41.2593 35.9354 35.3715 34.2788 29.8513C29.2193 29.6908 20.3157 26.1795 20.6287 14.1422C18.5863 15.3206 16.9523 17.6772 16.1354 18.8556C15.3184 20.0339 6.74025 27.8895 3.88086 29.0678C3.88086 28.1252 4.15318 26.5802 4.28934 25.9256C6.74025 24.6163 12.3773 20.898 15.3184 16.4989C18.2595 12.0998 21.1733 11 22.2626 11C22.129 16.9093 24.2239 28.3141 33.5632 27.554C30.9339 19.4246 27.5607 12.3438 23.2835 8.64285C19.791 9.82142 18.1827 11.3928 15.5223 16.1806ZM41.9109 26.7143C39.1776 23.1007 39.4054 15.901 39.8609 12.7528C40.0887 12.6159 40.6809 12.4243 41.2276 12.7528C40.2026 15.2166 41.2276 24.2505 41.9109 26.7143ZM43.4628 34.5714C46.5672 24.4545 48.7662 27.4181 49.6717 29.9728C48.3963 29.2531 47.6342 29.1248 46.8632 29.7067C47.1527 30.8503 47.2809 32.7285 46.2776 34.3172C45.1308 37.1418 49.7179 63.7741 52.7761 46.8263C52.7761 51.6685 52.3938 55.7037 48.5711 54.8966C48.2057 53.9709 47.6515 52.8716 47.03 51.639L47.03 51.6389C44.7103 47.0382 41.4548 40.5813 43.5911 34.3651L43.4628 34.5714Z",
    fill: "url(#paint7_linear_193_5378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6867 20.8214C13.7456 25.2205 5.55558 30.5121 3.10468 31.8214C2.96851 32.476 3.88074 28.1252 3.88074 29.0678C6.74012 27.8895 15.3183 20.0339 16.1353 18.8556C16.9522 17.6772 18.5862 15.3205 20.6286 14.1422C18.8148 15.7131 18.2626 18.4643 16.6867 20.8214Z",
    fill: "url(#paint8_linear_193_5378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2881 63.8299C18.9527 67.4218 20.1768 73.059 20.9557 75.4286C19.0862 72.7347 18.1737 67.322 17.9511 64.9524C17.3947 64.3288 15.2804 63.0068 11.2742 62.7075C5.1452 62.2496 9.68727 70.1835 13.6762 73.5861C13.9743 73.8264 14.2863 74.0665 14.6127 74.3061C14.3078 74.0992 13.9937 73.857 13.6762 73.5861C5.13188 66.7012 7.98081 59.7143 9.27117 59.7143C10.6065 59.7143 16.9496 61.585 20.2881 63.8299Z",
    fill: "url(#paint9_linear_193_5378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8563 68.3572V66C29.2145 69.5357 23.3936 65.6072 21.4533 64.4286C19.9011 67.1786 22.2294 74.25 24.9459 78.1786C23.3936 75.4286 22.1193 73.0714 22.1193 68.3572C25.2237 70.8714 36.1996 69.1429 40.8563 68.3572Z",
    fill: "#017B4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8563 68.3572V66C29.2145 69.5357 23.3936 65.6072 21.4533 64.4286C19.9011 67.1786 22.2294 74.25 24.9459 78.1786C23.3936 75.4286 21.7312 72.2857 21.7312 67.5714C24.8357 70.0857 36.1996 69.1429 40.8563 68.3572Z",
    fill: "url(#paint10_linear_193_5378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7311 54.6071C44.3161 50.8357 41.1341 38.5 43.8504 33.3929C41.5221 39.6786 46.8684 53.4286 49.2833 54.6071C51.2153 55.55 52.4167 52.5119 53.1639 51.0714C52.5172 53.6905 51.146 58.3786 47.7311 54.6071Z",
    fill: "#00FF9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7311 54.6071C44.3161 50.8357 41.1341 38.5 43.8504 33.3929C41.5221 39.6786 46.8684 53.4286 49.2833 54.6071C51.2153 55.55 52.4167 52.5119 53.1639 51.0714C52.5172 53.6905 51.146 58.3786 47.7311 54.6071Z",
    fill: "#00FF9A"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_193_5378)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.5369 29.8572C22.0305 28.9353 20.2925 18.7524 20.5668 14.1429C18.263 27.9715 29.2793 32.6072 35.313 32.6072C35.313 32.2143 34.866 30.7791 34.5369 29.8572Z",
    fill: "url(#paint11_linear_193_5378)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_di_193_5378)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0713 36.7567L19.6159 50.2857L39.5534 27.5",
    stroke: "url(#paint12_radial_193_5378)",
    strokeWidth: 4.71429
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_193_5378",
    x: 20.2549,
    y: 14.1429,
    width: 15.0586,
    height: 19.25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.785714
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 1 0 0 0 0 0.603922 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_193_5378"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_193_5378",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_di_193_5378",
    x: 5.02384,
    y: 25.2721,
    width: 40.3576,
    height: 36.3759,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.37857
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.02714
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0104125 0 0 0 0 0.0747253 0 0 0 0 0.0361377 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_193_5378"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_193_5378",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.785714,
    dy: -0.949405
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_193_5378"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_193_5378",
    x1: 26,
    y1: 0,
    x2: 26,
    y2: 77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008055"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001519"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_193_5378",
    x1: 26,
    y1: 0,
    x2: 26,
    y2: 77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.208258,
    stopColor: "#008055"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#001A11"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_193_5378",
    x1: 40.3582,
    y1: 12.9643,
    x2: 20.8843,
    y2: 21.0434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01EE91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001519",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_193_5378",
    x1: 1.55151,
    y1: 41.6428,
    x2: 39.6378,
    y2: 51.2401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FF9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435179,
    stopColor: "#00956D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FF9A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_193_5378",
    x1: 4.65599,
    y1: 42.8214,
    x2: 39.6292,
    y2: 51.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00956D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.131557,
    stopColor: "#00E8AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.244076,
    stopColor: "#00956D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472774,
    stopColor: "#00674C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003524"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_193_5378",
    x1: 4.80428,
    y1: 0,
    x2: 4.80428,
    y2: 23.2513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FF9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FF9A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_193_5378",
    x1: -0.283254,
    y1: 15.6458,
    x2: 7.81311,
    y2: 16.1056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FF9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FF9A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_193_5378",
    x1: 21.1333,
    y1: 76.4388,
    x2: 21.1333,
    y2: 4.68221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01704D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_193_5378",
    x1: 20.9554,
    y1: 14.9285,
    x2: 10.7283,
    y2: 26.1965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06FFA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#026949",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_193_5378",
    x1: 8.53784,
    y1: 62.2458,
    x2: 22.1939,
    y2: 64.9818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#014936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64626,
    stopColor: "#006348"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003527"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_193_5378",
    x1: 22.1257,
    y1: 66.6437,
    x2: 41.3829,
    y2: 69.3504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#014936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001A1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_193_5378",
    x1: 21.3429,
    y1: 17.2857,
    x2: 32.3754,
    y2: 31.2972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C16D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44034,
    stopColor: "#00C16D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#016546"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_193_5378",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.6859 39.8423) rotate(122.471) scale(18.5681 23.2101)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FF9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51D5A1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEggSuccess);
export default __webpack_public_path__ + "static/media/egg_success.ef0d8da106ec4f255631ba29f1077c4c.svg";
export { ForwardRef as ReactComponent };